import { createContext } from 'react';
import { MobileContextType } from './MobileContext.types';

export const MobileContext = createContext<MobileContextType | undefined>(undefined);
